export type QueryResult = {
   isLoading: boolean
   isError: boolean
   error: Error | null
   isStale: boolean
   isFetching: boolean
}

export function mergeQueryStates(states: QueryResult[]): QueryResult {
   return {
      isLoading: states.some((state) => state.isLoading),
      isError: states.some((state) => state.isError),
      error: states.find((state) => state.error)?.error || null,
      isStale: states.some((state) => state.isStale),
      isFetching: states.some((state) => state.isFetching),
   }
}
